import './css/index.css'

import Vue from 'vue'
import store from "./store/store.js"
import app from './app.vue'

import fastclick from 'fastclick'
import h5init from '@kkmh/h5init';
import { common } from "./js/common";

import * as Sentry from '@sentry/browser';

Vue.use(common)

Vue.config.productionip = false;

fastclick.attach(document.body);

// Vue异常捕获，上报异常到sentry
Vue.config.errorHandler = function (err) {
    console.log(err);
    Sentry.captureException(err);
  }

// h5初始化
function initNative() {
    (async () => {
        if (/kuaikan/i.test(navigator.userAgent)) {
            let res = await h5init({ login_mode: "unwanted" });
        }
        window.__nativeInit = true;
    })()
}

// 初始化vue
function initVue() {
    new Vue({
        store,
        el: '#app',
        data: function () {
            return {}
        },
        created: function () { },
        mounted: function () { },
        components: {
            app
        },
        methods: {}
    });
}
initNative();

initVue();


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/index.js